import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import {
  BIconLock,
  BIconUnlock,
  BIconPencil,
  BIconTrash,
  BIconPlus,
  BIconCheck2,
  BIconClipboardData,
  BIconExclamationCircleFill,
  BIconInfoCircleFill,
  BIconCheckCircleFill,
  BIconFiles,
  BIconCalendar2Date,
  BIconFileEarmarkSpreadsheet,
  BIconBasket,
  BIconPersonCheck,
  BIconArrowUpCircleFill,
  BIconArrowDownCircleFill,
  BIconX
} from "bootstrap-vue";

Vue.component(BIconLock);
Vue.component(BIconUnlock);
Vue.component(BIconPencil);
Vue.component(BIconTrash);
Vue.component(BIconPlus);
Vue.component(BIconCheck2);
Vue.component(BIconClipboardData);
Vue.component(BIconExclamationCircleFill);
Vue.component(BIconInfoCircleFill);
Vue.component(BIconCheckCircleFill);
Vue.component(BIconFiles);
Vue.component(BIconCalendar2Date);
Vue.component(BIconFileEarmarkSpreadsheet);
Vue.component(BIconBasket);
Vue.component(BIconPersonCheck);
Vue.component(BIconArrowUpCircleFill);
Vue.component(BIconArrowDownCircleFill);
Vue.component(BIconX);
